/* global THREE */

import aframe from "aframe";

/**
 * Specifies an envMap on an entity, without replacing any existing material
 * properties.
 */
aframe.registerComponent("spherical-envmap", {
  schema: {
    src: { default: "" },
    image: { type: "selector" },
    format: { default: "RGBAFormat" },
    intensity: { default: 1 },
    enableBackground: { default: false }
  },

  init: function() {
    const data = this.data;

    const src = data.image ? data.image.src : data.src;
    this.texture = new THREE.TextureLoader().load(src);
    this.texture.format = THREE[data.format];
    this.texture.mapping = THREE.EquirectangularReflectionMapping;

    if (data.enableBackground) {
      this.el.sceneEl.object3D.background = this.texture;
    }

    this.applyEnvMap();
    this.el.addEventListener("object3dset", this.applyEnvMap.bind(this));
  },

  applyEnvMap: function() {
    const mesh = this.el.getObject3D("mesh");
    const envMap = this.texture;
    const intensity = this.data.intensity;
    if (!mesh) return;

    mesh.traverse(function(node) {
      if (node.material && "envMap" in node.material) {
        node.material.envMap = envMap;
        node.material.envMapIntensity = intensity;
        node.material.needsUpdate = true;
      }
    });
  }
});
